// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3bwqT","name":"Header_name__aonJD","birthday":"Header_birthday__EQTNG","skeleton":"Header_skeleton__2hT4z"};